import apiService from '../apiService'

const apiPath = '/banner'

export const bannerController = (configService) => {
	const service = apiService(configService)
	return {
		getHomeBanner: () => {
			return service.get({
				url: `${apiPath}/home`,
			})
		},
	}
}
